import { useEffect, useState } from 'react'
import type { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { AppRoutes } from '@/config/routes'
import isEmpty from 'lodash/isEmpty'
import local from '@/services/local-storage/local'
import { addedSafesSlice, type AddedSafesState } from '@/store/addedSafesSlice'
import NewSafe from '@/components/welcome/NewSafe'
import { BRAND_NAME } from '@/config/constants'

const IndexPage: NextPage = () => {
  const router = useRouter()
  const { chain } = router.query
  const [hasAddedSafes, setHasAddedSafes] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    if (!router.isReady || router.pathname !== AppRoutes.index) {
      return
    }
    // TODO: Replace with useLocalStorage. For now read directly from localstorage so we have value on first render
    const addedSafes = local.getItem<AddedSafesState>(addedSafesSlice.name)
    const hasAnyAddedSafes = addedSafes !== null && !isEmpty(addedSafes)

    setHasAddedSafes(hasAnyAddedSafes)

    if (!hasAnyAddedSafes) {
      return
    }

    router.replace({
      pathname: AppRoutes.welcome.accounts,
      query: chain ? { chain } : undefined,
    })
  }, [router, chain])

  if (hasAddedSafes) {
    return null
  }

  return (
    <>
      <Head>
        <title>{`${BRAND_NAME} – Welcome`}</title>
      </Head>

      <NewSafe />
    </>
  )
}

export default IndexPage
